import React from "react"
import types from "prop-types"
import { activityHubFormEditPath } from "utils/routeHelpers"
import ExpandMenu, { ExpandMenuItem } from "shared/ExpandMenu"
import ExpandMenuEllipsisButton from "shared/buttons/ExpandMenuEllipsisButton"

const FormMenu = ({
  formSlug, onCopy, userCanCopy, userCanEdit,
}) => {
  if (!userCanEdit && !userCanCopy) return null

  return (
    <ExpandMenu expandMenuComponent={<ExpandMenuEllipsisButton />}>
      {
        userCanEdit && (
          <ExpandMenuItem href={activityHubFormEditPath(formSlug)}>
            Edit
          </ExpandMenuItem>
        )
      }
      {
        userCanCopy && (
          <ExpandMenuItem onClick={onCopy}>
            <span>Copy</span>
          </ExpandMenuItem>
        )
      }
    </ExpandMenu>
  )
}

FormMenu.propTypes = {
  formSlug: types.string.isRequired,
  onCopy: types.func.isRequired,
  userCanCopy: types.bool.isRequired,
  userCanEdit: types.bool.isRequired,
}

export default FormMenu
